export default "__VITE_ASSET__CCfmnrSc__"